import { QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/envelope';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, err) => {
          if (err instanceof ApiError && (err.isUnauthenticated() || err.isForbidden() || err.isNotFound())) return false;
          return failureCount < 1;
        },
        refetchOnWindowFocus: true,
        networkMode: 'always',
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (err) => {
        if (err instanceof ApiError && err.isUnauthenticated() && typeof window !== 'undefined') {
          const next = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.assign(`/login?next=${next}`);
        }
      },
    }),
  });
}
